<template>
  <a :href="getEvent">
    <slot>Add event</slot>
  </a>
</template>

<script>
import { createCalendarEvent } from '@/lib/calendar'

export default {
  name: 'AddToCalendar',
  props: {
    page: Object
  },
  computed: {
    getEvent () {
      const event = this.page
      const { event_start_date, event_end_date, event_start_time, event_end_time } = event
      const output = createCalendarEvent({
        event_start_date, event_end_date, event_start_time, event_end_time, 
        address: [event.location_address1, event.location_city].filter(p => p).join(', '),
        venue: event.location_name,
        url: 'https://dublab.com' + event.url,
        description: event.text,
        location: event.location_name,
        title: event.title
      })
      return output
    }
  }
}
</script>

<style>

</style>